import { render, staticRenderFns } from "./Timetable.vue?vue&type=template&id=5f155c4c&scoped=true&lang=pug&"
import script from "./Timetable.vue?vue&type=script&lang=ts&"
export * from "./Timetable.vue?vue&type=script&lang=ts&"
import style0 from "./Timetable.vue?vue&type=style&index=0&id=5f155c4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f155c4c",
  null
  
)

export default component.exports